import React from 'react'
import PropTypes from 'prop-types'

import Header from './Header'
import Body from './Body'

const Credit = ({ step, initialCredit, handleStep, handleInitialCredit, handleInitialMiles, handlePointsConversion, accessToken, balance }) => {
  return (
    <div>
      <Header step={step} />
      {step === 2 && (
        <Body
          handleStep={handleStep}
          handleInitialCredit={handleInitialCredit}
          handleInitialMiles={handleInitialMiles}
          initialCredit={initialCredit}
          handlePointsConversion={handlePointsConversion}
          accessToken={accessToken}
          balance={balance}
        />
      )}
    </div>
  )
}

Credit.propTypes = {
  step: PropTypes.number.isRequired,
  initialCredit: PropTypes.any,
  handleStep: PropTypes.func,
  handleInitialCredit: PropTypes.func,
  handleInitialMiles: PropTypes.func,
  handlePointsConversion: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object
}

export default Credit



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Credit/Credit.js